module.exports = __webpack_public_path__ + "img/ic_village_connectivity_center.e7b1a8b4.png";